(ns ycweb.app.blitz.aftersales.menu
  (:require
   [ycweb.components.common :as cmn]
   [ycweb.components.flow :as flow]
   [ycweb.components.grid :as grid]
   [ycweb.components.toaster :as toaster]
   [ycweb.components.transitions :as t]
   [ycweb.components.slats :as slats]
   [ycweb.components.wrapper :as w]
   [rum.core :as rum]
   [ycweb.util.comms :as comms]
   [ycweb.util.core :as u]))

(rum/defc menu < rum/reactive [app-atom]
  (let [pending-receiving (cmn/curact app-atom [:aftersales :menu :pending-receiving])

        functions
        [{:label "Prereceiving"
          :transition :aftersalesprereceiving/returncase-search}
         {:label "Receiving"
          :transition :aftersalesreceiving/printer
          :total pending-receiving}
         {:label "Query Item"
          :transition :aftersales/item-query}]]

    (w/wrapper app-atom "Aftersales" {}
      [[:div.page-body__main-content
        [:div.section
         [:h1.u-text-center
          {:class (u/bem :heading [:medium-large])}
          "Functions"]]
        [:div.slats
         (map
           (fn [{:keys [action transition] :as function}]
             (slats/function-slat
               (assoc function :on-click
                 (cond
                   action
                   #(grid/dispatch-action app-atom action {})

                   transition
                   #(t/transition-next app-atom transition)))))
           functions)]]]
      []
      (grid/pos-call-to-action
        {:left-fn #(t/transition-next app-atom :main-menu)
         :right-plain true}))))

(defmethod flow/render-screen :aftersales/menu [app-atom screen]
  (menu app-atom))

(defmethod comms/receive :aftersalesreceiving/pending [app-atom e]
  (toaster/close-subtle-progress app-atom)
  (swap! app-atom assoc-in [:aftersales :menu :pending-receiving] (:pending e))
  (t/transition-next app-atom :aftersales/menu))

(defmethod grid/action :aftersales/menu [app-atom]
  (toaster/open-subtle-progress app-atom)
  (comms/send :aftersalesreceiving/pending {}))